import { render } from "./SliderLimited.vue?vue&type=template&id=67c4826e&scoped=true&ts=true&lang=pug"
import script from "./SliderLimited.vue?vue&type=script&lang=ts&setup=true"
export * from "./SliderLimited.vue?vue&type=script&lang=ts&setup=true"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./SliderLimited.vue?vue&type=style&index=1&id=67c4826e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c4826e"]])

export default __exports__